import React, { useEffect, useState } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import avatar from "../../Assets/svg/avatar-img.svg";
import star from "../../Assets/svg/star.svg";
import exp from "../../Assets/svg/experience.svg";
import loc from "../../Assets/svg/location.svg";
import Button from "../modules/Button";
import ItemTab from "../modules/ItemTabs";
import ModalComponent from "../modules/Modal";
import Input from "../modules/Input";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Avatars from "../modules/AvatarGroup";
import PersonalProfile from "./personalProfile";
import ProfessionalProfile from "./ProfessionalProfile";
import EduProfile from "./EduProfile";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "../../Services";
import GradientLoader from "../modules/Loader";
// import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

function Profile(props) {
  const mentors = useSelector((state) => state.connect.mentors);
  const id = useSelector((state) => state.connect.profileId);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [uploading, setUploading] = useState(false);
  const [isWarning, setWarning] = useState(false);
  const [proffInfo, setProffInfo] = useState({});
  const navigate = useNavigate();
  const [requestOption, setRequestOption] = useState({
    topic: [],
    comment: "",
  });
  const [skills, setSkills] = useState([
    "Resume Building",
    "Job and Internship applications",
    "Job Interviews",
    "Networking Skills",
    "Academics",
  ]);
  const [tab, setTab] = useState("Personal Details");
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "Connection Request",
    countDown: " ",
    desc: "",
  });
  const [proSkills, setPro] = useState([
    "Marketing",
    "Leadership",
    "Product Ownership",
    "MS Excel",
    "Power BI",
    "Figma",
    "Search Engine Optimization",
    "Collaboration",
    "Powerpoint",
    "Chat GPT",
  ]);
  const [modelOptions, setModel] = useState([
    "Resume Building",
    "Job and Internship application",
    "Networking Skills",
    "Job Interviews",
    "Academics",
    "Something else",
  ]);
  const scholarContent = () => {
    return (
      <div className="feedback-content">
        <Avatars type="alumni" />
        <div className=" md-title ">
          Find more than 100+ Alumni members on the platform
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => navigate("/application/connect/alumni")}
            value={"Start Networking"}
            type={"contained"}
          />
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"I’ll check it out later"}
            type={"only-text"}
          />
        </div>
      </div>
    );
  };
  const makeRequest = async () => {
    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let data = {
      helpRequiredOn: requestOption.topic.join(", "),
      studentApplicationId: tokenData.applicationData.id,
      mentorId: proffInfo?.id,
      message: requestOption.comment,
    };

    try {
      const request = await api.mentorRequest(tokenData.token, data);
      console.log("users", request);
      return request;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const checkRequest = async () => {
    setUploading(true);
    try {
      const request = await makeRequest();
      console.log("users", request);
      setUploading(false);
      if (request.statusCode == 200) {
        setModalData({
          ...ModalData,
          type: "submit",
          title: (
            <div className="set-title">
              <div className="happy-icon">
                <img src={tick} alt="tick" />
              </div>
              Mentorship session request sent!
            </div>
          ),
          desc: "You’ll receive an update via email once your mentor accepts the request",
        });
      }
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      setUploading(false);

      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const mentorContent = () => {
    return (
      <div className="feedback-content">
        <div className="multi-btns">
          <div className="md-desc">
            Request a 1 on 1 session with {proffInfo.fullName}
            <div className="buttons-set">
              {modelOptions.map((item, index) => (
                <div
                  onClick={() =>
                    setRequestOption({
                      ...requestOption,
                      topic: [...requestOption.topic, item],
                    })
                  }
                  className={` subTitle ${
                    requestOption.topic.includes(item)
                      ? "contained"
                      : "btn-option"
                  }`}
                >
                  {item}
                </div>
              ))}
            </div>
            {isWarning && (
              <span className="warning-msg">
                Please select atleast one skill to proceed
              </span>
            )}
          </div>
        </div>
        <div className="comment-field">
          <Input
            onChange={
              (e) =>
                setRequestOption({
                  ...requestOption,
                  comment: e.replace(/[^a-zA-Z0-9. ]/g, ""),
                })
              // setFeedbackData("comment", e.replace(/[^a-zA-Z0-9. ]/g, ""))
            }
            placeholder={"Write your message"}
            multiline={true}
          />
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Cancel"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() =>
              requestOption?.topic?.length === 0
                ? setWarning(true)
                : checkRequest()
            }
            // disabled={requestOption?.topic?.length === 0}
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            // disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Send"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (id && mentors) {
      let content = mentors.filter((a) => a.id === id)[0];
      setProffInfo({ ...content });
    }
  }, []);
  console.log("mentors", mentors, id, proffInfo);
  return (
    <div className="profile-page">
      <div className="bc">
        <div
          onClick={() => navigate("/application/connect")}
          className="left-btn upload-top-text"
        >
          <NavigateNextIcon fontSize="small" />
          Back to Mentors
        </div>
      </div>
      <div className="mentor-card">
        <div className="image">
          {/* <img src={avatar} alt="avatar" /> */}
          {proffInfo?.image && proffInfo?.imageExtension && (
            <img
              // className="image"
              src={
                "data:image/" +
                proffInfo?.imageExtension +
                ";base64," +
                proffInfo?.image
              }
              alt="Preview"
              // style={{ maxWidth: "100%", height: "100%" }}
            />
          )}
        </div>
        <div className="mentor-right">
          <div className="mentor-top">
            <div className="top-left left">
              <div className="md-title">{proffInfo?.fullName}</div>
              <div className="set-title">{proffInfo?.expertise}</div>
              {proffInfo?.experience && (
                <div className="exp-line ">
                  <div className="left">
                    <img src={exp} alt="avatar" />
                    {proffInfo?.experience.includes("years")
                      ? proffInfo?.experience
                      : `${proffInfo?.experience} years`}{" "}
                    of experience
                  </div>
                  {/* <div className="left">
                  <img src={loc} alt="avatar" />
                  {proffInfo?.location}
                </div> */}
                  {/* <div className="right"></div> */}
                </div>
              )}
            </div>
            <div className="top-left right">
              <Button
                onClickHandler={() =>
                  setModalData({ ...ModalData, show: true })
                }
                type={"contained"}
                value={"Request Mentorship"}
              />
              {/* <div className="star-text">
                <span className="top-text">View reviews</span>
                <img src={star} alt="avatar" />
                <span className="text-two set-title">4.2</span>
              </div> */}
            </div>
          </div>
          <div className="options">
            <div className="option-top md-desc">I can help you with</div>
            <div className="skill-set">
              {proffInfo?.provideHelp?.split(",")?.map((item, index) => {
                return (
                  <div key={index} className="skill subTitle">
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="options">
            <div className="option-top upload-top-text">
              Professional Skills
            </div>
            <div className="skill-set">
              {proffInfo?.professionalSkills?.split(",")?.map((item, index) => {
                return (
                  <div key={index} className="skill subTitle">
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="tab-view">
        <ItemTab
          onChange={(e) => setTab(e)}
          list={[
            "Personal Details",
            "Professional Details",
            "Education Details",
          ]}
        />
      </div>
      {tab === "Personal Details" ? (
        <PersonalProfile item={proffInfo} />
      ) : tab === "Professional Details" ? (
        <ProfessionalProfile item={proffInfo} />
      ) : (
        <EduProfile item={proffInfo} />
      )}

      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={"mentor"}
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {ModalData.type === "confirm" ? (
            mentorContent()
          ) : ModalData.type === "network" ? (
            scholarContent()
          ) : (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  type: "network",
                  title: "",
                  desc: "",
                })
              }
              value={"Okay"}
              type={"contained"}
            />
          )}
        </ModalComponent>
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default Profile;
